import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import StudentProfilePage from "../../../components/Students/Profile/index";

const StudentProfile=(props)=>{
  return(
    <Aux>
    <Grid container>
      <Grid item container xs={11} sm={10} style={{ margin: "0 auto" }}>
      <StudentProfilePage {...props} />
      </Grid>
    </Grid>
  </Aux>
  )
}

export default StudentProfile;